import {
  Combobox,
  ComboboxDropdown,
  ComboboxOption,
  ComboboxSelectButton,
  ComboboxSelectCheck,
  Icon,
  Stack,
  Text,
} from '@eluve/components';

import { useAppointmentSelectableLocations } from '../useAppointmentSelectableLocations';

interface LocationOption {
  id: string;
  label: string;
}

interface LocationSelectorProps {
  tenantId: string;
  selectedLocationId?: string;
  onLocationSelected?: (location?: LocationOption) => void;
  variant?: 'default' | 'subtle';
  disabled?: boolean;
}

export const LocationSelector: React.FC<LocationSelectorProps> = ({
  tenantId,
  onLocationSelected,
  selectedLocationId,
  variant,
  disabled = false,
}) => {
  const locations = useAppointmentSelectableLocations(tenantId);

  const selectedLocation = locations.find(
    (location) => location.id === selectedLocationId,
  );

  const handleLocationSelected = (location?: LocationOption) => {
    onLocationSelected?.(location);
  };

  return (
    <Combobox disabled={disabled}>
      <ComboboxSelectButton
        className="w-full overflow-hidden border-transparent hover:bg-bg-quaternary"
        variant={variant}
        title={selectedLocation?.label}
      >
        <Stack className="overflow-hidden" direction="horizontal" gap={2}>
          <Icon name="MapPin" />
          <Text className="flex-1 truncate text-left">
            {selectedLocation?.label ?? 'Select a location'}
          </Text>
        </Stack>
      </ComboboxSelectButton>
      <ComboboxDropdown searchPlaceholder="Search locations...">
        {locations.map((location) => (
          <ComboboxOption
            key={location.id}
            onSelect={() => handleLocationSelected(location)}
          >
            <ComboboxSelectCheck
              className="mr-2"
              selected={selectedLocation?.id === location.id}
            />
            {location.label}
          </ComboboxOption>
        ))}
        <ComboboxOption onSelect={() => handleLocationSelected(undefined)}>
          <ComboboxSelectCheck
            selected={selectedLocation === undefined}
            className="mr-2"
          />
          No location
        </ComboboxOption>
      </ComboboxDropdown>
    </Combobox>
  );
};
